import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['currentUser'])
  },
  watch: {
    currentUser (newValue) {
      if (!newValue) {
        this.redirectToLogin()
      }
    }
  }
}
